import enterprise from './address.svg'
export default {
  enterprise: require('./enter'),
}
